<template>
  <el-table :data="feelist" v-loading="meta.loading" height="35rem">
    <!-- <el-table-column v-if="type == 'mange'" type="selection" width="55"></el-table-column> -->
    <el-table-column label="操作" width="100px;" align="center">
      <template slot-scope="{ $index, row }">
        <template v-if="type == 'mange'">
          <div v-if="row.type == 'add'">
            <el-button @click.native="save(row)" icon="el-icon-check" size="mini" circle></el-button>
            <el-button @click.native="clear" icon="el-icon-close" size="mini" circle></el-button>
          </div>
          <div v-else>
            <el-checkbox v-model="row.check"></el-checkbox>
          </div>
        </template>
        <template v-else>
          <div v-if="row.type == 'add'">
            <el-button @click.native="addItem(row)" icon="el-icon-check" size="mini" circle></el-button>
            <el-button @click.native="clear" icon="el-icon-close" size="mini" circle></el-button>
          </div>
          <div v-else>
            <!-- <el-button v-if="row.type == 'edit'" @click.native="save(row)" icon="el-icon-check" size="mini"
              circle></el-button>
            <el-button v-else @click.native="$set(row, 'type', 'edit')" icon="el-icon-edit" size="mini" circle
              type="primary"></el-button> -->
            <el-button @click.native="del(row.id, $index)" icon="el-icon-delete" size="mini" circle type="danger"></el-button>
          </div>
        </template>
      </template>
    </el-table-column>
    <el-table-column label="项目名称" align="center" prop="name" width="200px">
      <template slot-scope="{ row }">
        <div v-if="row.type == 'add' || row.type == 'edit'">
          <el-select allow-create :popper-append-to-body="false" @change="handleClick" style="width: 10rem" size="small" v-model="row.name" filterable placeholder="请选择" remote :filter-method="remoteMethod" value-key="code" default-first-option>
            <el-option v-if="feeItems && feeItems.length" value=" " disabled>
              <el-row style="width: 50rem; font-size: 15px" :gutter="16">
                <el-col :span="6">项目名称</el-col>
                <el-col :span="3">规格</el-col>
                <el-col :span="2" class="center">单位</el-col>
                <el-col :span="3" class="right">单价</el-col>
                <el-col :span="3" class="right">库存</el-col>
                <el-col :span="5" class="center">医保类别</el-col>
                <el-col :span="5" class="center">执行科室</el-col>
              </el-row>
            </el-option>
            <el-option v-for="item in feeItems" :key="item.id" :label="item.name" :value="item" style="font-size: 15px">
              <el-row style="width: 50rem; border-top: solid 1px #eee" :gutter="16">
                <el-col :span="6" style="white-space: break-spaces">{{ item.name }}</el-col>
                <el-col :span="3">{{ item.standard || "" }}</el-col>
                <el-col :span="2" class="center">{{ item.unit }}</el-col>
                <el-col :span="3" class="right">{{ item.price }}</el-col>
                <el-col :span="3" class="right">库存</el-col>
                <el-col :span="5" class="center">医保类别</el-col>
                <el-col :span="5" class="center">{{ item.execDeptCode | dictText("Dept") }}</el-col>

                <!-- <el-col :span="4" style="white-space: break-spaces">{{ item.name }}</el-col>
                    <el-col :span="3">{{ item.standard }}</el-col>
                    <el-col :span="3" class="right">{{ item.price }}</el-col>
                    <el-col :span="3" class="right">{{ item.quantity }}</el-col>
                    <el-col :span="2">{{ item.unit }}</el-col>
                    <el-col :span="4" class="tofEll">{{ item.manufacturerCode }}</el-col>
                    <el-col :span="5" class="center">{{ item.type | dictText("DrugType") }}</el-col> -->
              </el-row>
            </el-option>
          </el-select>
        </div>
        <div v-else><el-tag v-if="row.disabled" type="danger" size="small">已退费</el-tag>{{ row.name }}</div>
      </template>
    </el-table-column>
    <el-table-column label="类别" align="center" prop="rpClass" width="80px"> </el-table-column>
    <el-table-column label="规格" align="center" prop="standard" width="200px"> </el-table-column>
    <el-table-column label="单价（元）" align="center" prop="price" width="100px"> </el-table-column>
    <el-table-column label="数量" align="center" prop="quantity" width="120px">
      <template slot-scope="{ row }">
        <el-input v-if="row.type == 'add' || row.type == 'edit'" class="" v-model="row.quantity" maxlength="500" placeholder="请输入" size="small" clearable></el-input>
        <div v-else>{{ row.quantity }}</div>
      </template>
    </el-table-column>
    <el-table-column label="总金额（元）" align="center" prop="" width="140px">
      <template slot-scope="{ row }">
        {{ row.price ? row.price * row.quantity : "" }}
      </template>
    </el-table-column>
    <el-table-column label="医保范围" align="center" prop="claimType" width="110px">
      <template slot-scope="{ row }">
        <hic-dict-selector v-if="row.type == 'add' || row.type == 'edit'" dict-type="InsuranceRange" is-enum v-model="row.claimType" />
        <div v-else>{{ row.claimType }}</div>
      </template>
    </el-table-column>
    <el-table-column label="开单人" align="center" prop="doctorName"> </el-table-column>
    <el-table-column label="执行科室" align="center" prop="execDeptCode" width="130px">
      <template slot-scope="{ row }">
        <hic-dept-selector v-if="row.type == 'add' || row.type == 'edit'" class="f-w" v-model="row.execDeptCode" />
        <div v-else>
          {{ row.execDeptCode | dictText("Dept") }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="开单时间" align="center" prop="" width="210px">
      <template slot-scope="{ row }">
        <el-date-picker v-if="row.type == 'add' || row.type == 'edit'" size="small" style="width: 100%" class="" v-model="row.adviceTime" type="datetime" placeholder="请选择开单时间"></el-date-picker>
        <div v-else>{{ row.adviceTime | fmtDate }}</div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      type: String,
      list: Array,
      infoDetail: Object,
    },
    data() {
      return {
        selIndex: 0,
        meta: {
          loading: false,
          showBed: false,
        },
        condition: {},
        feeItems: [],
        feelist: [],
        tmpList: [],
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user"]),
    },
    filters: {},
    watch: {
      list: function (val) {
        this.showList(val);
      },
    },
    created() {},
    mounted() {
      if (!this.list) this.feelist.push(this.init());
    },
    methods: {
      showList(list) {
        // console.log('this.list=-===',this.list)
        this.feelist = this.$utils.Obj.clone(list);
        this.feelist.push(this.init());
      },
      init() {
        return {
          type: "add",
          ipNo: this.infoDetail.ipNo,
          rpClass: "治疗", //6,
          deptCode: this.user.deptCode,
          doctorCode: this.user.id,
          doctorName: this.user.name,
          adviceTime: this.$utils.Dt.now(),
          claimType: "医保内",
          quantity: 1,
          hospitalizationId: this.infoDetail.id,
          patientName: this.infoDetail.patientName,
          bedId: this.infoDetail.bedId,
          bedNo: this.infoDetail.bedNo,
        };
      },
      async remoteMethod(query) {
        let saveObj = this.feelist[0];
        if (!query) return;

        this.meta.drugLoading = true;

        let param = {
          // type:0,//[0,1,4],
          pageSize: 10,
          keyword: query,
          // category: '治疗'
        };
        let res = await api.MlItem.query(param);
        this.feeItems = res.items;

        this.meta.drugLoading = false;
      },
      handleClick(row) {
        let fds = ["name", "standard", "unit", "price", "execDeptCode"];
        let _obj = this.feelist[this.feelist.length - 1];
        fds.forEach((key) => {
          if (_obj[key]) _obj[key] = ""; //切换的时候清空之前选择
          if (row[key]) this.$set(_obj, key, row[key]);
        });
      },
      addItem(row) {
        if (!row.name) return this.$message.error("请选择收费项目");
        if (!row.quantity) return this.$message.error("请输入数量");
        row.type = "edit";
        this.tmpList.push(row);
        this.showList(this.tmpList);
        // this.feelist.push(row)
      },
      initList() {
        this.feelist = this.$utils.Obj.clone(this.list);
        this.feelist.push(this.init());
      },
      clear() {
        this.$set(this.feelist, this.feelist.length - 1, this.init());
      },
      save(row) {
        if (row) {
          if (!row.name) return this.$message.error("请选择收费项目");
          if (!row.quantity) return this.$message.error("请输入数量");
          this.$emit("save", row);
          return;
        }
        if (this.tmpList.length <= 0) return this.$message.error("请添加收费项目");
        for (let i = this.tmpList.length - 1; i >= 0; i--) {
          let item = this.tmpList[i];
          if (item.name && item.quantity) {
            this.tmpList.splice(i, 1);
            this.showList(this.tmpList);
            this.$emit("save", item);
          }
        }
      },
      del(id, index) {
        this.tmpList.splice(index, 1);
        this.showList(this.tmpList);
        return;
        this.$confirm("确定要删除该记录？", "取消", { type: "warning" })
          .then(() => {
            this.$emit("del", id);
          })
          .catch((e) => {});
      },
    },
  };
</script>
